import { createAction, props } from '@ngrx/store';
import { IAttachment, ISupportThread, ISupportMessage } from 'app/models/support';

export const clearAllItems = createAction('[Support] Clear All Items');

// Threads
export const loadUserThreadsFromState = createAction(
  '[Support] Load User Threads From State',
  props<{ take?: number; forceRefresh?: boolean }>(),
);
export const loadUserThreadsSuccess = createAction(
  '[Support API] Load User Threads Success',
  props<{ items: ISupportThread[] }>(),
);
export const loadUserThreadsFailure = createAction(
  '[Support API] Load User Threads Failure',
  props<{ error: any }>(),
);

export const loadThread = createAction('[Support] Load Thread', props<{ id: string }>());
export const loadThreadSuccess = createAction(
  '[Support API] Load Thread Success',
  props<{ item: ISupportThread }>(),
);
export const loadThreadFailure = createAction(
  '[Support API] Load Thread Failure',
  props<{ error: any }>(),
);

export const addThread = createAction(
  '[Support] Add Thread',
  props<{
    title: string;
    description: string;
    files: File[];
    /** Set when a draft is sent: the thread document is reused (status → 'open')
     *  and already-uploaded attachments are kept. */
    draftId?: string;
    draftAttachments?: IAttachment[];
  }>(),
);
export const addThreadSuccess = createAction(
  '[Support API] Add Thread Success',
  props<{ item: ISupportThread }>(),
);
export const addThreadFailure = createAction(
  '[Support API] Add Thread Failure',
  props<{ error: any }>(),
);

export const assignToMe = createAction('[Support] Assign To Me', props<{ id: string }>());
export const assignToMeSuccess = createAction(
  '[Support API] Assign To Me Success',
  props<{ id: string; uid: string; email: string }>(),
);
export const assignToMeFailure = createAction(
  '[Support API] Assign To Me Failure',
  props<{ error: any }>(),
);

export const archiveThread = createAction(
  '[Support] Archive Thread',
  props<{ id: string; archived: boolean }>(),
);
export const archiveThreadSuccess = createAction(
  '[Support API] Archive Thread Success',
  props<{ id: string; archived: boolean }>(),
);
export const archiveThreadFailure = createAction(
  '[Support API] Archive Thread Failure',
  props<{ error: any }>(),
);

export const markThreadRead = createAction(
  '[Support] Mark Thread Read',
  props<{ id: string; role: 'user' | 'developer' }>(),
);

export const setSelectedThread = createAction(
  '[Support] Set Selected Thread',
  props<{ id: string | null }>(),
);

// Messages
export const loadMessages = createAction(
  '[Support] Load Messages',
  props<{ threadId: string }>(),
);
export const loadMessagesSuccess = createAction(
  '[Support API] Load Messages Success',
  props<{ threadId: string; items: ISupportMessage[] }>(),
);
export const loadMessagesFailure = createAction(
  '[Support API] Load Messages Failure',
  props<{ error: any }>(),
);

export const addMessage = createAction(
  '[Support] Add Message',
  props<{
    threadId: string;
    body: string;
    files: File[];
    internal?: boolean;
  }>(),
);
export const addMessageSuccess = createAction(
  '[Support API] Add Message Success',
  props<{
    threadId: string;
    item: ISupportMessage;
    threadChanges?: Partial<ISupportThread>;
  }>(),
);
export const addMessageFailure = createAction(
  '[Support API] Add Message Failure',
  props<{ error: any }>(),
);

export const deleteThread = createAction(
  '[Support] Delete Thread',
  props<{ id: string }>(),
);
export const deleteThreadSuccess = createAction(
  '[Support API] Delete Thread Success',
  props<{ id: string }>(),
);
export const deleteThreadFailure = createAction(
  '[Support API] Delete Thread Failure',
  props<{ error: any }>(),
);

export const deleteMessage = createAction(
  '[Support] Delete Message',
  props<{ threadId: string; id: string }>(),
);
export const deleteMessageSuccess = createAction(
  '[Support API] Delete Message Success',
  props<{ threadId: string; id: string }>(),
);
export const deleteMessageFailure = createAction(
  '[Support API] Delete Message Failure',
  props<{ error: any }>(),
);
